module.exports = __webpack_public_path__ + "static/media/combo_ride_1.fa519ec4.png";